import { render, staticRenderFns } from "./tab-panel-page-edit-wrapper.vue?vue&type=template&id=3df953c5&scoped=true&"
import script from "./tab-panel-page-edit-wrapper.vue?vue&type=script&lang=js&"
export * from "./tab-panel-page-edit-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./tab-panel-page-edit-wrapper.vue?vue&type=style&index=0&id=3df953c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df953c5",
  null
  
)

export default component.exports